import { algoliasearch } from "algoliasearch"

import { AppSettings } from "@/settings"

class _AlgoliaSearchService {
  #config = {}

  /** @type {import('algoliasearch').SearchClient} */
  #client = null

  constructor() {
    this.#config = AppSettings.algoliaConfig()

    const { appID, apiKey } = this.#config

    // for some reason this sometimes is empty :/
    if (appID && apiKey) {
      this.#client = algoliasearch(appID, apiKey)
    }
  }

  client() {
    return this.#client
  }
}

export const AlgoliaSearch = new _AlgoliaSearchService()
